export const STATUS_DESPESAS = [
  { value: "1", label: "Liquidadas" },
  { value: "2", label: "Pendentes" },
  { value: "3", label: "Todas" },
];

export const FILTRAR_POR_DESPESAS = [
  { value: "6", label: "Vencimento", field: "vencimento" },
  { value: "3", label: "Liquidação", field: "liquidacao" },
  { value: "1", label: "Alteração", field: "alteracao" },
];

export const CHAVES_PIX = [
  { value: 1, label: "CPF", isDisabled: false },
  { value: 2, label: "CNPJ", isDisabled: false },
  { value: 3, label: "Celular", isDisabled: false },
  { value: 4, label: "Email", isDisabled: false },
  { value: 5, label: "Aleatória", isDisabled: false },
  { value: 6, label: "QR Code", isDisabled: true },
  { value: 7, label: "Dados bancários", isDisabled: false },
];

export const FORMA_PAGAMENTO_DESPESAS = [
  { value: "0", label: "Boleto" },
  { value: "1", label: "Cheque" },
  { value: "2", label: "Dinheiro" },
  { value: "3", label: "Cartão de crédito" },
  { value: "4", label: "Cartão de débito" },
  { value: "5", label: "Depósito" },
  { value: "6", label: "Cheque pré-datado" },
  { value: "7", label: "Débito automático" },
  { value: "8", label: "Trans. bancária" },
  { value: "9", label: "Doc/Ted" },
  { value: "10", label: "Outros" },
  { value: "11", label: "Tributo sem código de barras" },
  { value: "12", label: "Pix" },
  { value: "13", label: "DCTFWeb" },
];

export const REMESSA_DESPESAS = [
  { value: "0", label: "Todos", field: "0", codigos: ["9999"] },
  {
    value: "1",
    label: "Marcados para Remessa",
    field: "marcados",
    codigos: ["1"],
  },
  {
    value: "2",
    label: "Não marcados para Remessa",
    field: "naoMarcados",
    codigos: ["0", ""],
  },
  { value: "3", label: "Remessa enviadas", field: "enviadas", codigos: ["2"] },
  {
    value: "4",
    label: "Remessas confirmadas",
    field: "confirmadas",
    codigos: ["3"],
  },
  { value: "5", label: "Remessas com erro", field: "erro", codigos: ["-2"] },
  {
    value: "6",
    label: "Liquidada via retorno",
    field: "liquidadas",
    codigos: ["4"],
  },
];

export const STATUS_DESPESAS_ASSINATURAS = [
  { value: "0", label: "Todas" },
  { value: "1", label: "Liquidadas" },
  { value: "2", label: "Pendentes" },
];
